export * from './switch.component';
export * from './switch.module';
